import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IOrderPosition } from '../models/production-plan.models';

export interface IProductionPlanNotesDialogData {
	item: IOrderPosition;
}

@Component({
	selector: 'app-production-plan-notes-dialog',
	templateUrl: './production-plan-notes-dialog.component.html',
	styleUrl: './production-plan-notes-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ProductionPlanNotesDialogComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: IProductionPlanNotesDialogData,
		private dialogRef: MatDialogRef<ProductionPlanNotesDialogComponent>,
	) {}

	get orderNumber(): number {
		return this.data.item.orderNumber;
	}

	get position(): number {
		return this.data.item.position;
	}

	get alias(): string {
		return `${this.orderNumber}:${this.position}`;
	}

	close(): void {
		this.dialogRef.close();
	}
}
